export const ES_LOCALE_PRIMENG = {
  startsWith: 'Empieza con',
  contains: 'Contiene',
  notContains: 'No contiene',
  endsWith: 'Termina con',
  equals: 'Igual a',
  notEquals: 'Diferente de',
  noFilter: 'Sin filtro',
  lt: 'Menor que',
  lte: 'Menor o igual que',
  gt: 'Mayor que',
  gte: 'Mayor o igual que',
  dateIs: 'La fecha es',
  dateIsNot: 'La fecha no es',
  dateBefore: 'La fecha es anterior a',
  dateAfter: 'La fecha es posterior a',
  clear: 'Limpiar',
  apply: 'Aplicar',
  matchAll: 'Coincidir con todos',
  matchAny: 'Coincidir con cualquiera',
  addRule: 'Agregar regla',
  removeRule: 'Eliminar regla',
  accept: 'Sí',
  reject: 'No',
  choose: 'Seleccionar',
  upload: 'Subir',
  cancel: 'Cancelar',
  completed: 'Completado',
  pending: 'Pendiente',
  fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
  dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
  dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
  monthNames: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
  monthNamesShort: [
    'Ene',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Oct',
    'Nov',
    'Dic',
  ],
  chooseYear: 'Seleccionar año',
  chooseMonth: 'Seleccionar mes',
  chooseDate: 'Seleccionar fecha',
  prevDecade: 'Década anterior',
  nextDecade: 'Siguiente década',
  prevYear: 'Año anterior',
  nextYear: 'Siguiente año',
  prevMonth: 'Mes anterior',
  nextMonth: 'Siguiente mes',
  prevHour: 'Hora anterior',
  nextHour: 'Siguiente hora',
  prevMinute: 'Minuto anterior',
  nextMinute: 'Siguiente minuto',
  prevSecond: 'Segundo anterior',
  nextSecond: 'Siguiente segundo',
  am: 'am',
  pm: 'pm',
  today: 'Hoy',
  weekHeader: 'Sem',
  firstDayOfWeek: 0,
  dateFormat: 'dd/mm/yy',
  weak: 'Débil',
  medium: 'Media',
  strong: 'Fuerte',
  passwordPrompt: 'Ingresa una contraseña',
  emptyFilterMessage: 'No se encontraron resultados',
  searchMessage: '{0} resultados disponibles',
  selectionMessage: '{0} elementos seleccionados',
  emptySelectionMessage: 'Ningún elemento seleccionado',
  emptySearchMessage: 'No se encontraron resultados',
  emptyMessage: 'No hay opciones disponibles',
  'aria.trueLabel': 'Verdadero',
  'aria.falseLabel': 'Falso',
  'aria.nullLabel': 'No seleccionado',
  'aria.star': '1 estrella',
  'aria.stars': '{star} estrellas',
  'aria.selectAll': 'Todos los elementos seleccionados',
  'aria.unselectAll': 'Todos los elementos deseleccionados',
  'aria.close': 'Cerrar',
  'aria.previous': 'Anterior',
  'aria.next': 'Siguiente',
  'aria.navigation': 'Navegación',
  'aria.scrollTop': 'Ir arriba',
  'aria.moveTop': 'Mover arriba',
  'aria.moveUp': 'Mover hacia arriba',
  'aria.moveDown': 'Mover hacia abajo',
  'aria.moveBottom': 'Mover abajo',
  'aria.moveToTarget': 'Mover al destino',
  'aria.moveToSource': 'Mover al origen',
  'aria.moveAllToTarget': 'Mover todo al destino',
  'aria.moveAllToSource': 'Mover todo al origen',
  'aria.pageLabel': '{page}',
  'aria.firstPageLabel': 'Primera página',
  'aria.lastPageLabel': 'Última página',
  'aria.nextPageLabel': 'Siguiente página',
  'aria.prevPageLabel': 'Página anterior',
  'aria.rowsPerPageLabel': 'Filas por página',
  'aria.jumpToPageDropdownLabel': 'Ir al selector de página',
  'aria.jumpToPageInputLabel': 'Ir al campo de página',
  'aria.selectRow': 'Fila seleccionada',
  'aria.unselectRow': 'Fila deseleccionada',
  'aria.expandRow': 'Expandir fila',
  'aria.collapseRow': 'Colapsar fila',
  'aria.showFilterMenu': 'Mostrar menú de filtro',
  'aria.hideFilterMenu': 'Ocultar menú de filtro',
  'aria.filterOperator': 'Operador de filtro',
  'aria.filterConstraint': 'Restricción de filtro',
  'aria.editRow': 'Editar fila',
  'aria.saveEdit': 'Guardar edición',
  'aria.cancelEdit': 'Cancelar edición',
  'aria.listView': 'Vista de lista',
  'aria.gridView': 'Vista de cuadrícula',
  'aria.slide': 'Diapositiva',
  'aria.slideNumber': '{slideNumber}',
  'aria.zoomImage': 'Ampliar imagen',
  'aria.zoomIn': 'Acercar',
  'aria.zoomOut': 'Alejar',
  'aria.rotateRight': 'Rotar a la derecha',
  'aria.rotateLeft': 'Rotar a la izquierda',
};
